import React from 'react';
import PropTypes from 'prop-types';

import { NO_RESULTS } from './../ducks/filters/constants';

const RenderResults = ({ children, size }) => (
  size === 0 ?
    <p className="text-center">{NO_RESULTS}</p> :
    children
);

RenderResults.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.number.isRequired,
};

export default RenderResults;
